import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClipboardList,
  faUsers,
  faBullhorn,
  faCalendarAlt,
  faUserShield,
  faChartLine,
  faCog,
  faFileInvoiceDollar,
  faNewspaper,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";

import HeaderComponent from "../components/common/HeaderComponent";
import FooterComponent from "../components/common/FooterComponent";

export default function ExCoPortalPage() {
  const navigate = useNavigate();

  const adminSections = [
    {
      id: "membership-requests",
      title: "Membership Requests",
      description: "Review and manage new membership requests",
      icon: faClipboardList,
      color: "#3C0008",
      route: "/exco-portal/membership-requests",
      enabled: true,
      badge: "Active",
    },
    {
      id: "members",
      title: "Registered Members",
      description: "View and manage registered members",
      icon: faUsers,
      color: "#0056b3",
      route: "/exco-portal/member-management",
      enabled: false,
      badge: "Coming Soon",
    },
    {
      id: "committee",
      title: "Executive Committee",
      description: "Manage executive committee members and roles",
      icon: faUserShield,
      color: "#6f42c1",
      route: "exco-portal/committee",
      enabled: false,
      badge: "Coming Soon",
    },
    {
      id: "news",
      title: "Voice of Vidyaloka",
      description: "Manage Voice of Vidyaloka news channel",
      icon: faNewspaper,
      color: "#dc3545",
      route: "/exco-portal/voice-of-vidyaloka/publish",
      enabled: false,
      badge: "Coming Soon",
    },
    {
      id: "events",
      title: "Events",
      description: "Organize and manage events and activities",
      icon: faCalendarAlt,
      color: "#28a745",
      route: "/exco-portal/events/publish",
      enabled: false,
      badge: "Coming Soon",
    },
    {
      id: "donations",
      title: "Donations",
      description: "Track and manage member donations",
      icon: faFileInvoiceDollar,
      color: "#fd7e14",
      route: "/donations",
      enabled: false,
      badge: "Coming Soon",
    },
    {
      id: "communications",
      title: "Communications",
      description: "Manage email and SMS communications",
      icon: faEnvelope,
      color: "#ffc107",
      route: "/communications",
      enabled: false,
      badge: "Coming Soon",
    },
    {
      id: "announcements",
      title: "Announcements",
      description: "Create and manage announcements",
      icon: faBullhorn,
      color: "#e83e8c",
      route: "/announcements",
      enabled: false,
      badge: "Coming Soon",
    },
    {
      id: "analytics",
      title: "Analytics & Reports",
      description: "View insights and generate reports",
      icon: faChartLine,
      color: "#20c997",
      route: "/analytics",
      enabled: false,
      badge: "Coming Soon",
    },
    {
      id: "settings",
      title: "System Settings",
      description: "Configure system settings and preferences",
      icon: faCog,
      color: "#495057",
      route: "/settings",
      enabled: false,
      badge: "Coming Soon",
    },
  ];

  const handleCardClick = (section) => {
    if (section.enabled) {
      navigate(section.route);
    }
  };

  const getCardStyle = (section) => {
    return {
      cursor: section.enabled ? "pointer" : "not-allowed",
      opacity: section.enabled ? 1 : 0.6,
      transition: "all 0.3s ease",
      height: "100%",
    };
  };

  return (
    <div className="d-flex flex-column min-vh-100 overflow-x-hidden">
      <HeaderComponent user={null} />
      {/* <NavigationPanelComponent /> */}

      <main className="container my-5 flex-grow-1">
        {/* Page Header */}
        <div className="mb-5">
          <h2 className="fw-bold mb-2">ExCo Portal</h2>
          <p className="text-muted mb-4">
            The adminstration portal for the Executive Committee
          </p>

          {/* Quick Stats */}
          <div className="row g-3 mb-4">
            <div className="col-md-3">
              <div className="card rounded-3 border-vcg-muted">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <small className="text-muted d-block">
                        Pending Membership Requests
                      </small>
                      <h4 className="fw-bold mb-0">0</h4>
                    </div>
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: 50,
                        height: 50,
                        backgroundColor: "#fff3cd",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faClipboardList}
                        className="text-warning"
                        size="lg"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="card rounded-3 border-vcg-muted">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <small className="text-muted d-block">
                        Registered Members
                      </small>
                      <h4 className="fw-bold mb-0">0</h4>
                    </div>
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: 50,
                        height: 50,
                        backgroundColor: "#d1ecf1",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faUsers}
                        className="text-info"
                        size="lg"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="card rounded-3 border-vcg-muted">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <small className="text-muted d-block">
                        Upcoming Events
                      </small>
                      <h4 className="fw-bold mb-0">0</h4>
                    </div>
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: 50,
                        height: 50,
                        backgroundColor: "#d4edda",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faCalendarAlt}
                        className="text-success"
                        size="lg"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="card rounded-3 border-vcg-muted">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <small className="text-muted d-block">
                        Active Announcements
                      </small>
                      <h4 className="fw-bold mb-0">0</h4>
                    </div>
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: 50,
                        height: 50,
                        backgroundColor: "#f8d7da",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faBullhorn}
                        className="text-danger"
                        size="lg"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Admin Sections Grid */}
        <div className="mb-4">
          <h5 className="fw-bold mb-3">Administration Sections</h5>
          <div className="row g-4">
            {adminSections.map((section) => (
              <div key={section.id} className="col-lg-4 col-md-6">
                <div
                  className="card rounded-3 border-vcg-muted h-100"
                  style={getCardStyle(section)}
                  onClick={() => handleCardClick(section)}
                  onMouseEnter={(e) => {
                    if (section.enabled) {
                      e.currentTarget.style.transform = "translateY(-5px)";
                      e.currentTarget.style.boxShadow =
                        "0 0.5rem 1.5rem rgba(0,0,0,0.15)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 0.125rem 0.25rem rgba(0,0,0,0.075)";
                  }}
                >
                  <div className="card-body p-4">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div
                        className="rounded-3 d-flex align-items-center justify-content-center"
                        style={{
                          width: 60,
                          height: 60,
                          backgroundColor: section.enabled
                            ? section.color
                            : "#e9ecef",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={section.icon}
                          className="text-white"
                          size="lg"
                        />
                      </div>
                      <span
                        className={`badge ${
                          section.enabled ? "bg-success" : "bg-secondary"
                        }`}
                      >
                        {section.badge}
                      </span>
                    </div>

                    <h5 className="fw-bold mb-2">{section.title}</h5>
                    <p className="text-muted mb-0 small">
                      {section.description}
                    </p>

                    {section.enabled && (
                      <div className="mt-3">
                        <small className="text-primary fw-semibold">
                          Click to access →
                        </small>
                      </div>
                    )}

                    {!section.enabled && (
                      <div className="mt-3">
                        <small className="text-muted fst-italic">
                          Feature under development
                        </small>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      <FooterComponent />
    </div>
  );
}
